export default __webpack_public_path__ + "static/worksans-italic-webfont-af3099344b4905cc57e5dfda050b16c2.woff2";